(function () {
  function initNav(nav) {
    if (!nav || nav.dataset.vibrowlNavReady === 'true') return;
    nav.dataset.vibrowlNavReady = 'true';

    var toggle = nav.querySelector('.vibrowl-nav__toggle');
    var mobile = nav.querySelector('.vibrowl-nav__mobile');
    var overlay = nav.dataset.overlay === 'true';
    var menuOpen = false;

    function setNav(open) {
      menuOpen = !!open;
      var solid = !overlay || menuOpen || window.scrollY > 32;
      nav.classList.toggle('vibrowl-nav--solid', solid);
      if (toggle) toggle.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');
      if (mobile) mobile.hidden = !menuOpen;
    }

    if (mobile) {
      mobile.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setNav(false); });
      });
    }
    window.addEventListener('scroll', function () { setNav(menuOpen); }, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 750 && menuOpen) setNav(false);
    });
    setNav(false);
  }

  function init(root) {
    if (!root || root.dataset.vibrowlReady === 'true') return;
    root.dataset.vibrowlReady = 'true';

    root.querySelectorAll('.vws-scenarios img').forEach(function (image) {
      image.loading = 'eager';
    });

    // Only legacy scroll-driven heroes opt into copy fade; the current video
    // hero is visible immediately, matching the supplied reference build.
    if (root.dataset.vibrowlPage === 'home' && root.querySelector('main > section:first-child') && root.querySelector('main > section:first-child').classList.contains('vibrowl-scroll-hero')) {
      var hero = root.querySelector('main > section:first-child');
      var heroHeading = hero && hero.querySelector('h1');
      var heroCopy = heroHeading && heroHeading.parentElement;
      var heroShade = hero && hero.querySelector('.bg-\\[\\#0d140a\\]\\/80');
      var scrollCue = hero && hero.querySelector('.bottom-7');
      function updateHomeHero() {
        if (!hero || !heroCopy) return;
        var range = Math.max(1, hero.offsetHeight - window.innerHeight);
        var progress = Math.max(0, Math.min(1, (window.scrollY - hero.offsetTop) / range));
        var opacity;
        if (progress < 0.14) opacity = 0;
        else if (progress < 0.32) opacity = (progress - 0.14) / 0.18;
        else if (progress < 0.68) opacity = 1;
        else opacity = Math.max(0, 1 - ((progress - 0.68) / 0.24));
        var translate = progress < 0.32 ? 70 * (1 - Math.min(1, progress / 0.32)) : -55 * Math.max(0, (progress - 0.68) / 0.24);
        heroCopy.style.opacity = opacity.toFixed(3);
        heroCopy.style.transform = 'translateY(' + translate.toFixed(1) + 'px)';
        heroCopy.style.visibility = opacity > 0.01 ? 'visible' : 'hidden';
        heroCopy.style.pointerEvents = opacity > 0.5 ? 'auto' : 'none';
        if (heroShade) heroShade.style.opacity = (Math.min(0.82, progress * 1.25)).toFixed(3);
        if (scrollCue) scrollCue.style.opacity = Math.max(0, 1 - progress * 4).toFixed(3);
      }
      window.addEventListener('scroll', updateHomeHero, { passive: true });
      window.addEventListener('resize', updateHomeHero);
      updateHomeHero();
    }

    var reveals = root.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (item) { observer.observe(item); });
    } else {
      reveals.forEach(function (item) { item.classList.add('is-visible'); });
    }

    // Recreate the ZIP's subtle mouse-follow scenes on the homepage.  The
    // Liquid markup keeps the effect progressive-enhancement friendly: on
    // touch devices the images remain static and fully usable.
    if (root.dataset.vibrowlPage === 'home' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.matchMedia('(pointer: coarse)').matches) {
      root.querySelectorAll('main section .reveal > div[style*="perspective"] > div[style*="rotateX"]').forEach(function (scene) {
        if (scene.dataset.vibrowlSceneReady === 'true') return;
        scene.dataset.vibrowlSceneReady = 'true';
        var image = scene.querySelector('img');
        var glow = scene.querySelector('.pointer-events-none');
        function reset() {
          scene.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
          if (image) image.style.transform = 'translate(0px, 0px) scale(1.025)';
          if (glow) glow.style.background = 'radial-gradient(circle, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 55%)';
        }
        scene.addEventListener('pointermove', function (event) {
          var box = scene.getBoundingClientRect();
          var x = ((event.clientX - box.left) / box.width) * 2 - 1;
          var y = ((event.clientY - box.top) / box.height) * 2 - 1;
          x = Math.max(-1, Math.min(1, x));
          y = Math.max(-1, Math.min(1, y));
          scene.style.transform = 'rotateX(' + (-y * 3.5).toFixed(2) + 'deg) rotateY(' + (x * 4.5).toFixed(2) + 'deg) scale(1.012)';
          if (image) image.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px, ' + (y * 8).toFixed(1) + 'px) scale(1.045)';
          if (glow) glow.style.background = 'radial-gradient(circle at ' + ((x + 1) * 50).toFixed(1) + '% ' + ((y + 1) * 50).toFixed(1) + '%, rgba(255,255,255,.16) 0%, rgba(255,255,255,0) 48%)';
        });
        scene.addEventListener('pointerleave', reset);
      });
    }

    // Security scenarios use the same gentle parallax treatment as the
    // supplied reference build, while the copy card remains anchored to the
    // bottom of each image and lifts slightly on hover.
    if (root.dataset.vibrowlPage === 'security' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.matchMedia('(pointer: coarse)').matches) {
      root.querySelectorAll('.vws-scenarios .vws__card').forEach(function (card) {
        if (card.dataset.vibrowlScenarioReady === 'true') return;
        card.dataset.vibrowlScenarioReady = 'true';
        card.classList.add('vibrowl-scenario-interactive');
        var image = card.querySelector('.vws__card-media img');
        function reset() {
          card.style.setProperty('--scene-x', '0px');
          card.style.setProperty('--scene-y', '0px');
          if (image) image.style.transform = 'translate3d(0,0,0) scale(1.035)';
        }
        card.addEventListener('pointermove', function (event) {
          var box = card.getBoundingClientRect();
          var x = (((event.clientX - box.left) / box.width) * 2 - 1) * 7;
          var y = (((event.clientY - box.top) / box.height) * 2 - 1) * 5;
          card.style.setProperty('--scene-x', x.toFixed(1) + 'px');
          card.style.setProperty('--scene-y', y.toFixed(1) + 'px');
          if (image) image.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(1.055)';
        });
        card.addEventListener('pointerleave', reset);
        reset();
      });
    }

    root.querySelectorAll('#faq button, #support-faq button').forEach(function (button, index) {
      var panel = button.nextElementSibling;
      if (!panel || !panel.classList.contains('grid')) return;
      var icon = button.querySelector('svg');
      var verticalIconLine = icon && icon.querySelectorAll('path')[1];
      var initiallyOpen = panel.style.gridTemplateRows === '1fr';
      if (!panel.id) panel.id = 'vibrowl-faq-panel-' + index;
      button.type = 'button';
      button.setAttribute('aria-controls', panel.id);

      function setFaq(open) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.gridTemplateRows = open ? '1fr' : '0fr';
        panel.style.opacity = open ? '1' : '0';
        if (verticalIconLine) verticalIconLine.style.opacity = open ? '0' : '1';
      }

      setFaq(initiallyOpen);
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        setFaq(!open);
      });
    });

    if (window.location.hash === '#support-faq') {
      window.setTimeout(function () {
        var faq = document.getElementById('support-faq');
        if (faq) faq.scrollIntoView({ block: 'start' });
      }, 350);
    }

    root.querySelectorAll('.cursor-ew-resize').forEach(function (slider) {
      var images = slider.querySelectorAll(':scope > img');
      var handle = slider.querySelector(':scope > .pointer-events-none');
      if (images.length < 2 || !handle) return;
      var active = false;
      function position(event) {
        var box = slider.getBoundingClientRect();
        var clientX = event.clientX;
        var percent = Math.max(0, Math.min(100, ((clientX - box.left) / box.width) * 100));
        images[1].style.clipPath = 'inset(0 0 0 ' + percent + '%)';
        images[1].style.transition = 'none';
        handle.style.left = percent + '%';
        handle.style.transition = 'none';
      }
      slider.addEventListener('pointerdown', function (event) {
        active = true;
        slider.setPointerCapture(event.pointerId);
        position(event);
      });
      slider.addEventListener('pointermove', function (event) { if (active) position(event); });
      slider.addEventListener('pointerup', function () { active = false; });
      slider.addEventListener('pointercancel', function () { active = false; });
    });
  }

  document.querySelectorAll('[data-vibrowl-nav]').forEach(initNav);
  document.querySelectorAll('.vibrowl-exact').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    initNav(event.target.querySelector('[data-vibrowl-nav]'));
    init(event.target.querySelector('.vibrowl-exact'));
  });
})();

